// @deprecated - use breakpoints from encore-web
export const SM_SCREEN_MIN = 767;
export const SM_SCREEN_MAX = 768;
export const MD_SCREEN_MIN = 769;
export const MD_SCREEN_MAX = 991;
export const LG_SCREEN_MIN = 992;

// derived from Encore
// TODO https://anchorfm.atlassian.net/browse/WHEEL-803: Update A11Y Test Error Color to Utilize Encore Variable
export const ERROR_TEXT_COLOR = '#d31225';

export const GRAY_LINK_COLOR = '#504d65';
